import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import ClearIcon from '@material-ui/icons/Clear';

import { getUniquePropertyValues } from '../../../utils/helperFunctions';
import { CATEGORY_FILTERS, CATEGORY_HIERARCHY } from '../../../utils/constants/category';
import { useStyles, useListItemStyles } from './styles';

const Filters = ({ selected, setSelected }) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const listItemClasses = useListItemStyles();

	return (
		<div className={classes.rootContainer}>
			{Object.keys(CATEGORY_FILTERS).map((filterName, index) => (
				<Fragment key={index}>
					<Typography variant="h6" color="#212529" className={classes.categoriesTitle}>
						{t('components.categoriesDashboard.filters.' + filterName + '.title')}
					</Typography>

					<List style={{ padding: 0 }}>
						{getUniquePropertyValues(CATEGORY_HIERARCHY.categories, filterName).map((filterValue, subIndex) => {
							let isSelected = '';
							if (Array.isArray(filterValue)) {
								return null;
							} else {
								isSelected = selected.value === filterValue;
							}

							return (
								<ListItem disableGutters classes={listItemClasses} key={subIndex}>
									<ListItemText
										disableTypography
										onClick={() =>
											setSelected({
												type: filterName,
												value: filterValue
											})
										}
										tabIndex={0}
										role="button">
										<Typography
											variant="body1"
											className={clsx(classes.categoriesText, {
												[classes.categoriesTextSelected]: isSelected
											})}>
											{t('components.categoriesDashboard.filters.' + filterName + '.items.' + filterValue + '.title')}
										</Typography>
									</ListItemText>

									{isSelected && (
										<ListItemSecondaryAction>
											<IconButton
												edge="end"
												aria-label="clear-selection"
												onClick={() =>
													setSelected({
														type: null,
														value: null
													})
												}
												tabIndex={0}>
												<ClearIcon fontSize="small" />
											</IconButton>
										</ListItemSecondaryAction>
									)}
								</ListItem>
							);
						})}
					</List>
				</Fragment>
			))}
		</div>
	);
};

Filters.propTypes = {
	selected: PropTypes.object.isRequired,
	setSelected: PropTypes.func.isRequired
};

export default Filters;
